import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ConstellationSVG from '../components/ConstellationSVG';

const SplashNew = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/name-entry');
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-cosmic-dawn flex flex-col items-center justify-center relative overflow-hidden">
      {/* Constellation Background */}
      <div className="absolute inset-0 opacity-10 animate-pulse-slow">
        <ConstellationSVG />
      </div>
      
      {/* Logo */}
      <div className="text-center space-y-4 relative z-10">
        <h1 className="font-serif text-5xl md:text-6xl font-medium text-stone-900 tracking-tight">
          taraanaya
        </h1>
        <p className="text-sm text-stone-600 tracking-wide uppercase">
          Where the Stars Enlighten Your Path
        </p>
        
        {/* Pulsing Loader */}
        <div className="flex justify-center pt-8">
          <div className="w-2 h-2 bg-cosmic-500 rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default SplashNew;